import React from "react";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[var(--mm-bg)] flex items-center justify-center px-6 grain">
      <div className="max-w-lg w-full text-center">
        <XCircle size={48} className="mx-auto text-[var(--mm-cream-muted)] mb-6" />
        <div className="section-label mb-4">Order Cancelled</div>
        <h1 className="font-display text-4xl md:text-6xl italic text-[var(--mm-cream)] mb-4">
          No worries<span className="text-[var(--mm-accent)]">.</span>
        </h1>
        <p className="text-[var(--mm-cream-muted)] font-light mb-8 leading-relaxed">
          Your order was not placed and you were not charged. Come back when you're ready — mama will be waiting.
        </p>
        <a href="/" className="btn-primary">Back to Menu</a>
      </div>
    </div>
  );
}
